import moment from 'moment-timezone';

export const FLYTCHECK_PERMISSION = 'flytsuite.flytcheck.flytchecked.all';
export const FLYTCHECK_TIME_ZONE = 'America/Chicago';

export type FlytCheckRequisite = {
    classType?: string | null,
    deletedTs?: unknown | null,
    expiration?: string | null,
    type?: string | null
}

export function isFlytChecked(
    credentials?: ReadonlyArray<FlytCheckRequisite | null> | null,
    referenceTime: Date = new Date()
): boolean {
    const today = moment(referenceTime).tz(FLYTCHECK_TIME_ZONE).format('YYYY-MM-DD');

    return Boolean(
        credentials?.some(credential => {
            if (typeof credential?.expiration !== 'string') {
                return false;
            }
            const expiration = moment(credential.expiration, 'YYYY-MM-DD', true);

            return credential?.classType === 'flytsuite.requisite' &&
                credential?.type === 'FLYTCHECKED' &&
                !credential?.deletedTs &&
                expiration.isValid() &&
                expiration.format('YYYY-MM-DD') >= today;
        })
    );
}
